module.exports = __webpack_public_path__ + "static/media/Muli-Light.9ea7b841.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Muli-Light.ttf
// module id = 3253
// module chunks = 71